export const emptySideSheetPresets = {
    components: {
        Header: () => null,
        Content: () => null,
        Footer: () => null,
    },
    size: {
        medium: {},
        large: {},
    },
};
//# sourceMappingURL=sideSheet.js.map